<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jV9O7x/tc-custom/9780062950758.jpg?1726574123534" alt="This image is the cover for the book Kindness and Wonder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kindness and Wonder
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A pop culture celebration of Fred Rogers and the enduring legacy of his beloved, award-winning PBS show <i>Mister Rogers’ Neighborhood</i> that offers essential wisdom to help us in our troubled times.</b><br/><br/><i>Won’t you be my neighbor?</i></p><p>For more than thirty years, Fred Rogers was a beloved fixture in American homes. Warm and welcoming, he spoke directly to children—and their parents—about the marvels of the world, the things that worried them, and above all, the importance of being themselves. Dressed in his cardigan and sneakers, Fred Rogers offered a wholesome message of generosity and love that changed the landscape of television and shaped a generation of children. Kindness and Wonder pays tribute to this cultural icon: the unique, gentle man who embodied the best of what we could be. </p><p>Looking back at the history of the show and the creative visionary behind it, pop culture aficionado Gavin Edwards reminds us of the indelible lessons and insights that Mister Rogers conveyed—what it means to be a good person, to be open-hearted, to be thoughtful, to be curious, to be compassionate—and why they matter. Beautifully crafted, infused with Mister Rogers’ gentle spirit, and featuring dozens of interviews with people whose lives were touched by Fred Rogers—ranging from Rita Moreno to NFL Hall of Famer Lynn Swann—<i>Kindness and Wonder</i> is a love letter to this unforgettable cultural hero and role model, and the beautiful neighborhood he created.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gavin Edwards
      </h2>
      
      <p class="authorDescription body article"><P>Gavin Edwards is a contributing editor at <I>Rolling Stone</I> who has written five articles for the magazine about Blink-182 for the magazine since 1999. He is the <I>New York Times</I> bestselling author of seven books. He lives in Charlotte, North Carolina, with his wife and their two sons.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b87de4e